





































































































import { Vue, Component } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { Key, KeyType, CsrState, KeyCsr } from "bancojs";
import AgDataTable, { AgDataTableOptions } from "@/components/AgDataTable.vue";
import { saveAs } from "file-saver";

@Component({
  components: {
    AgDataTable,
  },
})
export default class AdminKeysCsrIndex extends Vue {
  async created() {
    await this.loadData();
  }

  async loadData() {
    if (this.$route.params.key_id) {
      try {
        this.table.loading = true;
        const res = await $api.client.admin.keys
          .listCsrForKey(Number(this.$route.params.key_id))
          .toPromise();
        this.table.data = res;
      } catch (err) {
        console.log(err);
      } finally {
        this.table.loading = false;
      }
    }
  }

  getStateString(val: CsrState) {
    return val === "PENDING" ? "Pendiente" : "Completado";
  }

  downloadCsr(val: KeyCsr) {
    const blob = new Blob([val.csr], { type: "text/plain;charset=utf-8" });
    saveAs(blob, ["bcentral", val.id, Date.now()].join("_") + ".csr");
  }

  openRemove(item: KeyCsr) {
    this.table.selected = item;
  }

  closeRemove() {
    this.table.selected = null;
  }

  get removeDialog() {
    return !!this.table.selected;
  }

  async removeUser(csrId: number) {
    try {
      this.dialog.loading = true;
      await $api.client.admin.keys
        .destroyCsrForKeyAndId(Number(this.$route.params.key_id), csrId)
        .toPromise();
      this.dialog.loading = false;
      this.closeRemove();
      await this.loadData();
    } catch (err) {
      console.log(err);
      this.dialog.loading = false;
      this.closeRemove();
    }
  }

  dialog: {
    loading: boolean;
  } = {
    loading: false,
  };

  table: {
    loading: boolean;
    selected: KeyCsr | null;
    data?: KeyCsr[];
    options: AgDataTableOptions[];
  } = {
    loading: true,
    selected: null,
    data: undefined,
    options: [
      {
        header: {
          text: "#",
          value: "$index",
          width: 60,
          filterable: false,
          sortable: false,
        },
        row: {
          type: "INDEX",
        },
      },
      {
        header: {
          text: "ID",
          value: "id",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          label: true,
          color: {},
        },
      },
      {
        header: {
          text: "Estado",
          value: "state",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          label: true,
          color: {
            COMPLETED: "success",
            PENDING: "warn",
          },
          transform: this.getStateString,
        },
      },
      {
        header: {
          text: "Certificado",
          value: "certificate_fingerprint",
          class: "text-no-wrap",
        },
        row: {
          type: "LINK",
          to: "/admin/certificates/{certificate_fingerprint}/edit",
        },
      },
      {
        header: {
          text: "",
          class: "text-no-wrap",
          value: "$options",
          sortable: false,
          filterable: false,
        },
        row: {
          type: "OPTIONS",
          options: [
            {
              label: "Descargar CSR",
              icon: "mdi-file-download",
              action: this.downloadCsr,
            },
            {
              label: "Importar Certificado",
              icon: "mdi-text-box-plus",
              link: "/admin/certificates/new?key_id={$key_id}&csr_id={id}",
              disabled: (item: KeyCsr) => {
                return item.state == "COMPLETED";
              },
            },
            {
              label: "Eliminar",
              icon: "mdi-delete",
              action: (item: KeyCsr) => {
                this.openRemove(item);
              },
            },
          ],
        },
      },
    ],
  };
}
